var _style;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconoAutorizacionesGris(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 85 101.8",
    style: {
      enableBackground: "new 0 0 85 101.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M53.5,95.1H4.1V3.6h63.5v60.8c1.2,0.2,2.3,0.3,3.3,0.7V3.7c0-1.7-1.3-3-3-3H3.6c-1.7,0-3,1.3-3,3v91.6 c0,1.7,1.3,3,3,3h55C56.8,97.6,55,96.4,53.5,95.1z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M55.5,32h-6.4c-0.5,0-1-0.5-1-1v-4h-4c-0.5,0-1-0.5-1-1v-6.4c0-0.5,0.5-1,1-1h4v-3.8c0.2-0.5,0.5-0.8,1-0.8 h6.4c0.5,0,1,0.5,1,1v4h4c0.5,0,1,0.5,1,1v6.4c0,0.5-0.5,1-1,1h-4v4C56.5,31.5,56,32,55.5,32z M50.1,30.2h4.6v-4c0-0.5,0.5-1,1-1 h4v-4.6h-4c-0.5,0-1-0.5-1-1v-3.8h-4.6v4c0,0.5-0.5,1-1,1h-4v4.6h4c0.5,0,1,0.5,1,1V30.2z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M61.8,56.1H14.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5h47.3c0.8,0,1.5,0.7,1.5,1.5 C63.3,55.5,62.6,56.1,61.8,56.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M32.1,24.1H14.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5H32c0.8,0,1.5,0.7,1.5,1.5S32.7,24.1,32.1,24.1z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M32.1,30.8H14.5c-0.8,0-1.5-0.7-1.5-1.5s0.7-1.5,1.5-1.5H32c0.8,0,1.5,0.7,1.5,1.5 C33.5,30.2,32.7,30.8,32.1,30.8z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M58.5,65.5h-44c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h39.3C55.2,67.3,56.7,66.4,58.5,65.5z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M48.1,77.9H14.5c-0.8,0-1.5,0.7-1.5,1.5s0.7,1.5,1.5,1.5h33.2C47.8,79.9,47.9,78.9,48.1,77.9z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M65.3,101.1c-10.6,0-19-8.6-19-19c0-10.6,8.6-19,19-19s19,8.6,19,19C84.4,92.5,75.9,101.1,65.3,101.1z  M65.3,65.5c-9.1,0-16.4,7.3-16.4,16.4s7.3,16.4,16.4,16.4S81.6,91,81.6,81.9C81.8,72.8,74.4,65.5,65.3,65.5z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#63616C"
    },
    d: "M62.6,89c-0.5,0-0.8-0.2-1.2-0.5l-5-4.3c-0.8-0.7-0.8-1.8-0.2-2.6c0.7-0.8,1.8-0.8,2.6-0.2l3.5,3.1l8.6-9.1 c0.7-0.7,1.8-0.8,2.6-0.2c0.7,0.7,0.8,1.8,0.2,2.6L64,88.3C63.6,88.8,63.1,89,62.6,89z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoAutorizacionesGris);
export default __webpack_public_path__ + "static/media/iconoAutorizacionesGris.9eb2318d.svg";
export { ForwardRef as ReactComponent };